import css from 'styled-jsx/css';

const styles = css.global`#santander-canais {
  overflow: hidden;
  padding: 32px 0;
}

#santander-canais .slide {
  flex: 0 0 240px;
}

#santander-canais .headline-canais {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
}

.sub-headline {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
  margin-bottom: 24px;
}

.canais-card {
  height: 138px;
  min-width: 240px;
  /* border: 1px solid #cccccc; */
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(34, 34, 34, 0.12);
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;

  cursor: pointer;

  padding: 28px 0 28px 17px;

  margin-right: 24px;

  margin-left: 0;

  transition: 0.2s ease;
}

.canais-card.fix-size {
  width: calc(251px + 24px);
}

.canais-card h3 {
  color: #444;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  margin: 8px 0 16px 0;
}

.canais-card h3.wpp-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.canais-card h3.wpp-icon-wrapper ins {
  text-decoration: none;
}

.canais-card h3.wpp-icon-wrapper amp-img {
  margin: 0 4px;
}

.canais-card u {
  color: #cc0000;
  font-family: 'SantanderText';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-decoration: underline;
}

.canais-card.no-margin {
  margin-right: 0;
}

.slide {
  margin-left: 0;
  margin-right: 0;
}

.canais-card:hover {
  box-shadow: 0px 2px 16px -2px rgb(34 34 34 / 40%);
}

#canais-whatsapp,
#canais-whatsapp .qr-code>div {
  position: relative;
}

#canais-whatsapp .qr-code {
  display: none;
  z-index: 999;
}

#santander-canais amp-carousel .amp-carousel-button {
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
}

#santander-canais .home-pagination {
  margin-top: 24px;
}

#santander-canais .home-pagination .embla__prev {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_left_red.svg);
  background-size: 24px 24px;
}

#santander-canais .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_right_red.svg);
  background-size: 24px 24px;
}


@media (min-width: 768px) {
  .headline {
    max-width: 1000px;
  }

}

@media (min-width: 992px) {
  #santander-canais {
    padding: 40px 0;
  }

  /* .canais-card {
    height: 170px;
    width: 288px;
  } */

  .canais-card h3.wpp-icon-wrapper ins {
    display: none;
  }

  #canais-whatsapp .qr-code {
    display: block;
    position: absolute;
    right: 16px;
    top: 50px;
    transform: translate(0, -50%);
  }

  /* #santander-canais .custom-carousel .fill-height {
    overflow: hidden;
  } */

  #santander-canais .custom-carousel .embla__container {
    overflow: visible;
  }

  #santander-canais .custom-carousel .embla__prev {
    left: -37px;
    background-size: 2rem;
    background-image: url(static/amp/shared/assets/left-small.png);
  }

  #santander-canais .custom-carousel .embla__next {
    right: -37px;
    background-size: 2rem;
    background-image: url(static/amp/shared/assets/right-small.png);
  }
}

@media (min-width: 1080px) {
  #santander-canais .home-pagination {
    display: none;
  }

}

@media (min-width: 1400px) {

  #santander-canais .custom-carousel .embla__prev,
  #santander-canais .custom-carousel .embla__next {
    display: none;
  }
}`;

export default styles;